/**
 * Floating WhatsApp Button Component
 *
 * Displays a floating WhatsApp button on landing pages
 * for quick customer support access.
 */

import React from 'react';
import { Fab, Tooltip, keyframes } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// Pulse animation for attention
const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
`;

const WHATSAPP_NUMBER = '5541996111900';
const WHATSAPP_MESSAGE = 'Olá! Preciso de suporte com a Clinafy.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

const FloatingWhatsApp: React.FC = () => {
  return (
    <Tooltip
      title="Precisa de ajuda? Fale conosco!"
      placement="left"
      arrow
    >
      <Fab
        component="a"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Abrir WhatsApp"
        sx={{
          position: 'fixed',
          bottom: { xs: 16, md: 24 },
          right: { xs: 16, md: 24 },
          zIndex: 1050,
          bgcolor: '#25D366',
          color: '#FFFFFF',
          width: { xs: 56, md: 64 },
          height: { xs: 56, md: 64 },
          animation: `${pulse} 2s infinite`,
          boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
          transition: 'all 0.3s ease',
          '&:hover': {
            bgcolor: '#128C7E',
            transform: 'scale(1.1)',
            boxShadow: '0 6px 24px rgba(37, 211, 102, 0.5)',
          },
          '&:active': {
            transform: 'scale(0.95)',
          },
        }}
      >
        <WhatsAppIcon sx={{ fontSize: { xs: 28, md: 32 } }} />
      </Fab>
    </Tooltip>
  );
};

export default FloatingWhatsApp;
